import React, { useEffect, useState } from 'react';
import Input from '../../common/components/Input';
import './PAMINotificationsSection.scss';
import { I18n } from 'react-redux-i18n';
import Card from '../../common/components/Card/Card';

export const PAMI_CONTRACT_ID = 7;

export const PAMINotificationsSection = ({
    notificaciones,
    onInputChange,
}: {
    notificaciones: {
        dias_antes_registracion_1: number | null;
        dias_antes_registracion_2: number | null;
        dias_antes_evidencia_1: number | null;
        dias_antes_evidencia_2: number | null;
    };
    onInputChange: (notificaciones: {
        dias_antes_registracion_1: number | null;
        dias_antes_registracion_2: number | null;
        dias_antes_evidencia_1: number | null;
        dias_antes_evidencia_2: number | null;
    }) => void;
}) => {
    const [inputState, setInputState] = useState({
        dias_antes_registracion_1: notificaciones?.dias_antes_registracion_1?.toString() || '',
        dias_antes_registracion_2: notificaciones?.dias_antes_registracion_2?.toString() || '',
        dias_antes_evidencia_1: notificaciones?.dias_antes_evidencia_1?.toString() || '',
        dias_antes_evidencia_2: notificaciones?.dias_antes_evidencia_2?.toString() || '',
    });

    // Sync local state when the prop changes
    useEffect(() => {
        setInputState({
            dias_antes_registracion_1: notificaciones?.dias_antes_registracion_1?.toString() || '',
            dias_antes_registracion_2: notificaciones?.dias_antes_registracion_2?.toString() || '',
            dias_antes_evidencia_1: notificaciones?.dias_antes_evidencia_1?.toString() || '',
            dias_antes_evidencia_2: notificaciones?.dias_antes_evidencia_2?.toString() || '',
        });
    }, [notificaciones]);

    const {
        dias_antes_registracion_1,
        dias_antes_registracion_2,
        dias_antes_evidencia_1,
        dias_antes_evidencia_2,
    } = inputState;

    const handleChange = (key: string, value: string) => {
        // Only allow numeric characters and empty string
        if (!/^\d*$/.test(value)) return;

        const updatedInputState = {
            ...inputState,
            [key]: value,
        };
        setInputState(updatedInputState);

        onInputChange({
            dias_antes_registracion_1: updatedInputState.dias_antes_registracion_1
                ? parseInt(updatedInputState.dias_antes_registracion_1)
                : null,
            dias_antes_registracion_2: updatedInputState.dias_antes_registracion_2
                ? parseInt(updatedInputState.dias_antes_registracion_2)
                : null,
            dias_antes_evidencia_1: updatedInputState.dias_antes_evidencia_1
                ? parseInt(updatedInputState.dias_antes_evidencia_1)
                : null,
            dias_antes_evidencia_2: updatedInputState.dias_antes_evidencia_2
                ? parseInt(updatedInputState.dias_antes_evidencia_2)
                : null,
        });
        setInputState(updatedInputState);
    };

    return (
        <Card
            className='card-custom'
            classHead='card-head-mod'
            classBody='card-body-custom pami-notification-section'
            title={I18n.t('contract.versionDetail.pami.title')}
            detail=''
        >
            <div className='registration-container'>
                <label>{I18n.t('contract.versionDetail.pami.daysBeforeRegistration')}</label>
                <div className='registration-days-input-container'>
                    <Input
                        value={dias_antes_registracion_1}
                        type='number'
                        label='1'
                        error={dias_antes_registracion_1?.length == 0}
                        handleChange={(value: string) =>
                            handleChange('dias_antes_registracion_1', value)
                        }
                    />
                    <Input
                        value={dias_antes_registracion_2}
                        type='number'
                        label='2'
                        error={dias_antes_registracion_2?.length == 0}
                        handleChange={(value: string) =>
                            handleChange('dias_antes_registracion_2', value)
                        }
                    />
                </div>
            </div>
            <div className='evidence-container'>
                <label>{I18n.t('contract.versionDetail.pami.daysBeforeEvidence')}</label>
                <div className='evidence-days-input-container'>
                    <Input
                        value={dias_antes_evidencia_1}
                        type='number'
                        label='1'
                        error={dias_antes_evidencia_1?.length == 0}
                        handleChange={(value: string) =>
                            handleChange('dias_antes_evidencia_1', value)
                        }
                    />
                    <Input
                        value={dias_antes_evidencia_2}
                        type='number'
                        label='2'
                        error={dias_antes_evidencia_2?.length == 0}
                        handleChange={(value: string) =>
                            handleChange('dias_antes_evidencia_2', value)
                        }
                    />
                </div>
            </div>
        </Card>
    );
};
